import { useEffect, useRef, useState } from "react";
import useStore from "../store/store";
import { IEmployee } from "../types/employee";
import { fuzzyMatch } from "../utils";

type ClockEmployeeSearchPropsType = {
  companyName: string;
  companyEmployees: Array<IEmployee>;
};

const ClockEmployeeSearch = ({
  companyName,
  companyEmployees,
}: ClockEmployeeSearchPropsType) => {
  const { setActiveTimeEmployee, activeTimeEmployee, allocations, worktimes } =
    useStore();

  const [name, setName] = useState("");
  const [showEmployeeList, setShowEmployeeList] = useState(false);

  const ClickOutsideHandler = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowEmployeeList(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  ClickOutsideHandler(wrapperRef);

  useEffect(() => {
    if (activeTimeEmployee === null) return;
    setName(`${activeTimeEmployee?.firstName} ${activeTimeEmployee?.lastName}`);
  }, [activeTimeEmployee]);

  return (
    <div className="w-fit relative" ref={wrapperRef}>
      <div
        className="flex flex-col w-96"
        onClick={() => setShowEmployeeList(true)}
      >
        <label htmlFor="employeeName" className="font-bold pb-1 text-xs">
          {companyName}
        </label>
        <input
          type="text"
          name="employeeName"
          id="employeeName"
          placeholder="zoek op medewerkersnaam"
          className="border-0 border-b-2 text-xs"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete="off"
        />
      </div>

      {showEmployeeList && (
        <div className="max-h-40 w-full overflow-y-scroll border border-light-gray absolute z-10 bg-white">
          <ul>
            {companyEmployees
              .filter((employee) =>
                fuzzyMatch(name, employee.firstName + employee.lastName)
              )
              .map((employee) => {
                return (
                  <li key={employee._id}>
                    <button
                      className="hover:bg-red hover:text-white p-3 cursor-pointer w-full text-left text-xs"
                      onClick={() => {
                        setName(`${employee.firstName} ${employee.lastName}`);
                        setShowEmployeeList(false);

                        const isAllocated = allocations.filter(
                          (alloc) =>
                            alloc.employeeId === employee._id &&
                            alloc.date ===
                              new Date().toISOString().split("T")[0] &&
                            alloc.status === "available"
                        );

                        const employeeWorktime = worktimes.find(
                          (worktime) => worktime.employeeId === employee._id
                        );

                        if (isAllocated.length > 0) {
                          setActiveTimeEmployee(employee);
                        } else {
                          setActiveTimeEmployee(employee);
                          //@ts-ignore
                          document.getElementById("notInPlanning")?.showModal();
                        }
                      }}
                    >
                      {employee.firstName} {employee.lastName}
                    </button>
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ClockEmployeeSearch;
